import { Organization } from "@/shared/types/userTypes";
import { ServiceLine } from "@/shared/types/serviceLineTypes";
import { CircuitTaggingType } from "./l2vpnTypes";

// Terminal Type Enum
export enum TerminalType {
  STARLINK_PERFORMANCE_GEN_3 = 'STARLINK_PERFORMANCE_GEN_3',
  STARLINK_PERFORMANCE_GEN_2 = 'STARLINK_PERFORMANCE_GEN_2',
  STARLINK_ENTERPRISE_V4 = 'STARLINK_ENTERPRISE_V4',
  STARLINK_MINI = 'STARLINK_MINI',
  STARLINK_STANDARD_4 = 'STARLINK_STANDARD_4',
  STARLINK_STANDARD_4X = 'STARLINK_STANDARD_4X',
  NOT_SET = 'NOT_SET'
}

// Active Alert Interface
export interface ActiveAlert {
  code: number;
  message: string;
}

export interface L2VPNCircuitTerminalRecord {
  circuitId: string;
  circuitName: string | null;
  taggingType: CircuitTaggingType;
  customerVlans: number[];
  serviceVlan: number;
}

export interface IPAllocation {
  ipv4: string[];
  ipv6Ue: string[];
  ipv6Cpe: string[];
  createdAt: string;
}

export interface RouterData {
  routerId: string;
  nickname: string | null;
  userTerminalId: string;
  configId: string | null;
  hardwareVersion: string | null;
  lastBonded: boolean | null;
}

// User Terminal Interface
export interface UserTerminal {
  userTerminalId: string;
  kitSerialNumber: string;
  dishSerialNumber: string;
  type: TerminalType | null;
  notes: string | null;
  organization: Organization | null;
  serviceLine: ServiceLine | null;
  l2VpnCircuits: L2VPNCircuitTerminalRecord[] | null;
  ipAllocation: IPAllocation | null;
  eligibleTargetOrganizations: Organization[] | null;
  routers: RouterData[] | null;
  locationComplianceViolation: boolean | null;
  lastLocation: string | null;
  activeAlerts: ActiveAlert[] | null;
}

// Terminal Telemetry Interface
export interface TerminalTelemetry {
  utcTimestampNs: string | null;
  downlinkThroughput: number | null;
  uplinkThroughput: number | null;
  pingDropRateAvg: number | null;
  pingLatencyMsAvg: number | null;
  obstructionPercentTime: number | null;
  uptime: number | null;
  signalQuality: number | null;
  h3CellId: string | null;
  secondsUntilSwupdateRebootPossible: number | null;
  runningSoftwareVersion: string | null;
  utcTimestamp: string | null;
}

// Terminal Route Response Interface
export interface TerminalRoutePoint {
  h3CellId: string;
  utcTimestamp: string;
}